import { Handler } from "../types/store-types";
import {
    GetZapierAuthURLRequestActionType,
    GetZapierAuthURLSuccessActionType,
    GetZapierAuthURLFailureActionType,
    GetHubspotAuthURLRequestActionType,
    IHubspotAuthState,
    IHubspotDataState,
    IHubspotTablesState,
    IHubspotPropertyState,
    GetHubspotAuthURLSuccessActionType,
    GetHubspotAuthURLFailureActionType,
    GetHubspotDataRequestActionType,
    GetHubspotDataSuccessActionType,
    GetHubspotDataFailureActionType,
    GetHubspotStatusRequestActionType,
    GetHubspotStatusSuccessActionType,
    GetHubspotStatusFailureActionType,
    IUpdateHubspotPropertyFailureData,
    UpdateHubspotPropertyFailureActionType,
    IUpdateHubspotPropertySuccessData,
    UpdateHubspotPropertySuccessActionType,
    UpdateHubspotPropertyRequestActionType,
    GetHubspotTablesRequestActionType,
    GetHubspotTablesSuccessActionType,
    GetHubspotTablesFailureActionType,
    IGetHubspotTablesFailureData,
    IHubspotStatusState,
    IGoogleSheetsState,
    GetGoogleSheetsAuthURLRequestActionType,
    GetGoogleSheetsAuthURLSuccessActionType,
    GetGoogleSheetsAuthURLFailureActionType,
    GetGoogleSheetsRequestActionType,
    GetGoogleSheetsSuccessActionType,
    GetGoogleSheetsFailureActionType,
    UpdateGoogleSheetsConfigRequestActionType,
    UpdateGoogleSheetsConfigSuccessActionType,
    IUpdateGoogleSheetsConfigFailureData,
    UpdateGoogleSheetsConfigFailureActionType,
    GetIntegrationStatusesRequestActionType,
    GetIntegrationStatusesSuccessActionType,
    GetIntegrationStatusesFailureActionType,
    IGetIntegrationStatusesSuccessData,
    IGetIntegrationStatusesFailureData,
    GetGoogleSheetWorksheetsRequestActionType,
    GetGoogleSheetWorksheetsSuccessActionType,
    IGetGoogleSheetsWorksheetsSuccessData,
    GetGoogleSheetWorksheetsFailureActionType,
    IGetGoogleSheetsWorksheetsFailureData,
    IntegrationActionTypes,
    GetMailchimpAuthURLRequestActionType,
    GetMailchimpAuthURLFailureActionType,
    GetMailchimpAuthURLSuccessActionType,
    UpdateMailchimpConfigRequestActionType,
    UpdateMailchimpConfigSuccessActionType,
    IUpdateMailchimpConfigSuccessData,
    UpdateMailchimpConfigFailureActionType,
    IUpdateMailchimpConfigFailureData,
    GetMailchimpRequestActionType,
    GetMailchimpSuccessActionType,
    GetMailchimpFailureActionType,
    GetMailchimpSelectedFieldsRequestActionType,
    GetMailchimpSelectedFieldsSuccessActionType,
    GetMailchimpSelectedFieldsFailureActionType,
    IMailchimpListsState,
    IMailchimpSelectedFieldsState,
    IMailchimpAuthState,
    IMailchimpConfigState,
    IDisconnectIntegrationState,
    DisconnectIntegrationRequestActionType,
    DisconnectIntegrationSuccessActionType,
    DisconnectIntegrationFailureActionType,
    IZapierDataState,
    IZapierTokensState,
    GetZapierTokensRequestActionType,
    GetZapierTokensSuccessActionType,
    GetZapierTokensFailureActionType,
    DisconnectZapierFailureActionType,
    DisconnectZapierSuccessActionType,
    DisconnectZapierRequestActionType,
    IZapierDisconnectionState,
    IZapierAuthState,
    GetZapierZapsRequestActionType,
    GetZapierZapsSuccessActionType,
    GetZapierZapsFailureActionType,
} from "./types";

const getGoogleSheetsAuthURLRequest: Handler<IGoogleSheetsState, GetGoogleSheetsAuthURLRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getGoogleSheetsAuthURLSuccess: Handler<IGoogleSheetsState, GetGoogleSheetsAuthURLSuccessActionType> = (
    state,
    { payload },
) => {
    return { ...state, isLoading: false, authUrl: payload.data, error: null };
};

const getGoogleSheetsAuthURLFailure: Handler<IGoogleSheetsState, GetGoogleSheetsAuthURLFailureActionType> = (
    state,
    { payload },
) => {
    return { ...state, isLoading: false, error: payload };
};

const getGoogleSheetsRequest: Handler<IGoogleSheetsState, GetGoogleSheetsRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getGoogleSheetsSuccess: Handler<IGoogleSheetsState, GetGoogleSheetsSuccessActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, sheetsData: payload.data.list, error: null };
};

const getGoogleSheetsFailure: Handler<IGoogleSheetsState, GetGoogleSheetsFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, error: payload };
};

const updateGoogleSheetsConfigRequest: Handler<
    IGoogleSheetsState,
    UpdateGoogleSheetsConfigRequestActionType
> = state => {
    return { ...state, isLoading: true };
};

const updateGoogleSheetsConfigSuccess: Handler<IGoogleSheetsState, UpdateGoogleSheetsConfigSuccessActionType> = (
    state,
    action: { payload: any },
) => {
    return {
        ...state,
        success: true,
        message: action.payload.data.message || action.payload.message,
        config: action.payload.data.data.config?.googleSheet || null,
        isLoading: false,
        error: null,
    };
};

const updateGoogleSheetsConfigFailure: Handler<IGoogleSheetsState, UpdateGoogleSheetsConfigFailureActionType> = (
    state,
    action: { payload: IUpdateGoogleSheetsConfigFailureData },
) => {
    return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload,
    };
};

const getGoogleSheetWorksheetRequest: Handler<
    IGoogleSheetsState,
    GetGoogleSheetWorksheetsRequestActionType
> = state => {
    return { ...state, isLoading: true };
};
const getGoogleSheetWorksheetSuccess: Handler<IGoogleSheetsState, GetGoogleSheetWorksheetsSuccessActionType> = (
    state,
    action: { payload: IGetGoogleSheetsWorksheetsSuccessData },
) => {
    return {
        ...state,
        isLoading: false,
        error: null,
        worksheets: action.payload.worksheets,
    };
};

const getGoogleSheetWorksheetFailure: Handler<IGoogleSheetsState, GetGoogleSheetWorksheetsFailureActionType> = (
    state,
    action: { payload: IGetGoogleSheetsWorksheetsFailureData },
) => {
    return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload,
    };
};

const getIntegrationStatusesRequest: Handler<IGoogleSheetsState, GetIntegrationStatusesRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getIntegrationStatusesSuccess: Handler<IGoogleSheetsState, GetIntegrationStatusesSuccessActionType> = (
    state,
    action: { payload: IGetIntegrationStatusesSuccessData },
) => {
    return {
        ...state,
        statuses: action.payload.data,
        isLoading: false,
        error: null,
    };
};

const getIntegrationStatusesFailure: Handler<IGoogleSheetsState, GetIntegrationStatusesFailureActionType> = (
    state,
    action: { payload: IGetIntegrationStatusesFailureData },
) => {
    return {
        ...state,
        isLoading: false,
        error: action.payload,
    };
};

const getZapierAuthURLRequest: Handler<IZapierAuthState, GetZapierAuthURLRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getZapierAuthURLSuccess: Handler<IZapierAuthState, GetZapierAuthURLSuccessActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, authUrl: payload.authUrl, formId: payload.formId, error: null };
};

const getZapierAuthURLFailure: Handler<IZapierAuthState, GetZapierAuthURLFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, error: payload };
};

const getZapierZapsRequest: Handler<IZapierDataState, GetZapierZapsRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getZapierZapsSuccess: Handler<IZapierDataState, GetZapierZapsSuccessActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, zaps: payload.data, errors: null };
};

const getZapierZapsFailure: Handler<IZapierDataState, GetZapierZapsFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, errors: payload };
};

const getZapierTokensRequest: Handler<IZapierTokensState, GetZapierTokensRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getZapierTokensSuccess: Handler<IZapierTokensState, GetZapierTokensSuccessActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, zapierToken: payload.data.zapier, error: null };
};
const getZapierTokensFailure: Handler<any, GetZapierTokensFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, error: payload };
};

const disconnectZapierRequest: Handler<IZapierDisconnectionState, DisconnectZapierRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const disconnectZapierSuccess: Handler<IZapierDisconnectionState, DisconnectZapierSuccessActionType> = (
    state,
    { payload },
) => {
    return { ...state, isLoading: false, token: payload.data, error: null };
};

const disconnectZapierFailure: Handler<IZapierDisconnectionState, DisconnectZapierFailureActionType> = (
    state,
    { payload },
) => {
    return { ...state, isLoading: false, error: payload };
};
const getHubspotAuthURLRequest: Handler<IHubspotAuthState, GetHubspotAuthURLRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getHubspotAuthURLSuccess: Handler<IHubspotAuthState, GetHubspotAuthURLSuccessActionType> = (
    state,
    { payload },
) => {
    return { ...state, isLoading: false, authUrl: payload.data, error: null };
};

const getHubspotAuthURLFailure: Handler<IHubspotAuthState, GetHubspotAuthURLFailureActionType> = (
    state,
    { payload },
) => {
    return { ...state, isLoading: false, error: payload };
};

const getHubspotDataRequest: Handler<IHubspotDataState, GetHubspotDataRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getHubspotDataSuccess: Handler<IHubspotDataState, GetHubspotDataSuccessActionType> = (state, { payload }) => {
    return {
        ...state,
        isLoading: false,
        hubspotData: payload.data.config,
        error: null,
        success: true,
        message: "",
    };
};

const getHubspotDataFailure: Handler<IHubspotDataState, GetHubspotDataFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, error: payload, success: false };
};

const getHubspotStatusRequest: Handler<IHubspotStatusState, GetHubspotStatusRequestActionType> = state => {
    return { ...state };
};

const getHubspotStatusSuccess: Handler<IHubspotStatusState, GetHubspotStatusSuccessActionType> = (
    state,
    { payload },
) => {
    return {
        ...state,
        status: payload.data,
        message: payload.message,
        success: payload.success,
    };
};

const getHubspotStatusFailure: Handler<IHubspotStatusState, GetHubspotStatusFailureActionType> = (
    state,
    { payload },
) => {
    return { ...state, isLoading: false, errors: payload };
};

const updateHubspotPropertyRequest: Handler<IHubspotPropertyState, UpdateHubspotPropertyRequestActionType> = state => {
    return { ...state, isLoading: true };
};
const updateHubspotPropertySuccess: Handler<IHubspotPropertyState, UpdateHubspotPropertySuccessActionType> = (
    state,
    action: { payload: IUpdateHubspotPropertySuccessData },
) => {
    return {
        ...state,
        success: true,
        message: action.payload.message,
        data: action.payload.data
            ? {
                  table: action.payload.data.tableName,
                  fields: {
                      [action.payload.data.tableName]: action.payload.data.fields.tableName,
                  },
                  _id: action.payload.data._id || "",
              }
            : null,
        isLoading: false,
        error: null,
    };
};
const updateHubspotPropertyFailure: Handler<IHubspotPropertyState, UpdateHubspotPropertyFailureActionType> = (
    state,
    action: { payload: IUpdateHubspotPropertyFailureData },
) => {
    return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload,
    };
};

const getHubspotTablesRequest: Handler<IHubspotTablesState, GetHubspotTablesRequestActionType> = state => {
    return { ...state, isLoading: true };
};
const getHubspotTablesSuccess: Handler<IHubspotTablesState, GetHubspotTablesSuccessActionType> = (
    state,
    { payload },
) => {
    return {
        ...state,
        success: true,
        message: payload.message,
        hubspotTablesData: payload.data,
        isLoading: false,
        error: null,
    };
};
const getHubspotTablesFailure: Handler<IHubspotTablesState, GetHubspotTablesFailureActionType> = (
    state,
    action: { payload: IGetHubspotTablesFailureData },
) => {
    return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload,
    };
};

const getMailchimpAuthURLRequest: Handler<IMailchimpAuthState, GetMailchimpAuthURLRequestActionType> = state => {
    return { ...state, isLoading: true };
};

const getMailchimpAuthURLSuccess: Handler<IMailchimpAuthState, GetMailchimpAuthURLSuccessActionType> = (
    state,
    { payload },
) => {
    return { ...state, isLoading: false, authUrl: payload.data, error: null };
};

const getMailchimpAuthURLFailure: Handler<IMailchimpAuthState, GetMailchimpAuthURLFailureActionType> = (
    state,
    { payload },
) => {
    return { ...state, isLoading: false, error: payload };
};
const updateMailchimpConfigRequest: Handler<IMailchimpConfigState, UpdateMailchimpConfigRequestActionType> = state => {
    return { ...state, isLoading: true };
};
const updateMailchimpConfigSuccess: Handler<IMailchimpConfigState, UpdateMailchimpConfigSuccessActionType> = (
    state,
    action: { payload: IUpdateMailchimpConfigSuccessData },
) => {
    return {
        ...state,
        success: true,
        message: action.payload.message,
        configData: action.payload,
        isLoading: false,
        error: null,
    };
};
const updateMailchimpConfigFailure: Handler<IMailchimpConfigState, UpdateMailchimpConfigFailureActionType> = (
    state,
    action: { payload: IUpdateMailchimpConfigFailureData },
) => {
    return {
        ...state,
        isLoading: false,
        success: false,
        error: action.payload,
    };
};

const getMailchimpRequest: Handler<IMailchimpListsState, GetMailchimpRequestActionType> = state => {
    return { ...state, isLoading: true };
};
const getMailchimpSuccess: Handler<IMailchimpListsState, GetMailchimpSuccessActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, mailchimpData: payload.mailchimpData.data, error: null };
};
const getMailchimpFailure: Handler<IMailchimpListsState, GetMailchimpFailureActionType> = (state, { payload }) => {
    return { ...state, isLoading: false, error: payload };
};

const getMailchimpSelectedFIeldsRequest: Handler<
    IMailchimpSelectedFieldsState,
    GetMailchimpSelectedFieldsRequestActionType
> = state => {
    return { ...state, isLoading: true };
};
const getMailchimpSelectedFIeldsSuccess: Handler<
    IMailchimpSelectedFieldsState,
    GetMailchimpSelectedFieldsSuccessActionType
> = (state, { payload }) => {
    return { ...state, isLoading: false, selectedFields: payload.selectedFields, error: null };
};
const getMailchimpSelectedFIeldsFailure: Handler<
    IMailchimpSelectedFieldsState,
    GetMailchimpSelectedFieldsFailureActionType
> = (state, { payload }) => {
    return { ...state, isLoading: false, error: payload };
};

const disconnectIntegrationRequest: Handler<
    IDisconnectIntegrationState,
    DisconnectIntegrationRequestActionType
> = state => {
    return { ...state, isLoading: true };
};

const disconnectIntegrationSuccess: Handler<IDisconnectIntegrationState, DisconnectIntegrationSuccessActionType> = (
    state,
    { payload },
) => {
    return {
        ...state,
        success: true,
        message: payload.message,
        data: payload.data,
    };
};

const disconnectIntegrationFailure: Handler<IDisconnectIntegrationState, DisconnectIntegrationFailureActionType> = (
    state,
    { payload },
) => {
    return { ...state, isLoading: false, error: payload };
};

export const disconnectIntegrationHandlers = {
    [IntegrationActionTypes.DISCONNECT_INTEGRATION_REQUEST]: disconnectIntegrationRequest,
    [IntegrationActionTypes.DISCONNECT_INTEGRATION_SUCCESS]: disconnectIntegrationSuccess,
    [IntegrationActionTypes.DISCONNECT_INTEGRATION_FAILURE]: disconnectIntegrationFailure,
};
export const zapierAuthHandlers = {
    [IntegrationActionTypes.GET_ZAPIER_AUTH_URL_REQUEST]: getZapierAuthURLRequest,
    [IntegrationActionTypes.GET_ZAPIER_AUTH_URL_SUCCESS]: getZapierAuthURLSuccess,
    [IntegrationActionTypes.GET_ZAPIER_AUTH_URL_FAILURE]: getZapierAuthURLFailure,
};
export const zapierZapsHandlers = {
    [IntegrationActionTypes.GET_ZAPIER_ZAPS_REQUEST]: getZapierZapsRequest,
    [IntegrationActionTypes.GET_ZAPIER_ZAPS_SUCCESS]: getZapierZapsSuccess,
    [IntegrationActionTypes.GET_ZAPIER_ZAPS_FAILURE]: getZapierZapsFailure,
};
export const zapierTokensHandlers = {
    [IntegrationActionTypes.GET_ZAPIER_TOKENS_REQUEST]: getZapierTokensRequest,
    [IntegrationActionTypes.GET_ZAPIER_TOKENS_SUCCESS]: getZapierTokensSuccess,
    [IntegrationActionTypes.GET_ZAPIER_TOKENS_FAILURE]: getZapierTokensFailure,
};

export const zapierDisconnectionHandlers = {
    [IntegrationActionTypes.DISCONNECT_ZAPIER_REQUEST]: disconnectZapierRequest,
    [IntegrationActionTypes.DISCONNECT_ZAPIER_SUCCESS]: disconnectZapierSuccess,
    [IntegrationActionTypes.DISCONNECT_ZAPIER_FAILURE]: disconnectZapierFailure,
};
export const hubspotAuthHandlers = {
    [IntegrationActionTypes.GET_HUBSPOT_AUTH_URL_REQUEST]: getHubspotAuthURLRequest,
    [IntegrationActionTypes.GET_HUBSPOT_AUTH_URL_SUCCESS]: getHubspotAuthURLSuccess,
    [IntegrationActionTypes.GET_HUBSPOT_AUTH_URL_FAILURE]: getHubspotAuthURLFailure,
};

export const hubspotDataHandlers = {
    [IntegrationActionTypes.GET_HUBSPOT_DATA_REQUEST]: getHubspotDataRequest,
    [IntegrationActionTypes.GET_HUBSPOT_DATA_SUCCESS]: getHubspotDataSuccess,
    [IntegrationActionTypes.GET_HUBSPOT_DATA_FAILURE]: getHubspotDataFailure,
};

export const hubspotStatusHandlers = {
    [IntegrationActionTypes.GET_HUBSPOT_STATUS_REQUEST]: getHubspotStatusRequest,
    [IntegrationActionTypes.GET_HUBSPOT_STATUS_SUCCESS]: getHubspotStatusSuccess,
    [IntegrationActionTypes.GET_HUBSPOT_STATUS_FAILURE]: getHubspotStatusFailure,
};

export const hubspotPropertyHandlers = {
    [IntegrationActionTypes.UPDATE_HUBSPOT_PROPERTY_REQUEST]: updateHubspotPropertyRequest,
    [IntegrationActionTypes.UPDATE_HUBSPOT_PROPERTY_SUCCESS]: updateHubspotPropertySuccess,
    [IntegrationActionTypes.UPDATE_HUBSPOT_PROPERTY_FAILURE]: updateHubspotPropertyFailure,
};

export const hubspotTablesHandlers = {
    [IntegrationActionTypes.GET_HUBSPOT_TABLES_REQUEST]: getHubspotTablesRequest,
    [IntegrationActionTypes.GET_HUBSPOT_TABLES_SUCCESS]: getHubspotTablesSuccess,
    [IntegrationActionTypes.GET_HUBSPOT_TABLES_FAILURE]: getHubspotTablesFailure,
};

export const googleSheetsAuthHandlers = {
    [IntegrationActionTypes.GET_GOOGLESHEETS_AUTH_URL_REQUEST]: getGoogleSheetsAuthURLRequest,
    [IntegrationActionTypes.GET_GOOGLESHEETS_AUTH_URL_SUCCESS]: getGoogleSheetsAuthURLSuccess,
    [IntegrationActionTypes.GET_GOOGLESHEETS_AUTH_URL_FAILURE]: getGoogleSheetsAuthURLFailure,
};

export const googleSheetsDataHandlers = {
    [IntegrationActionTypes.GET_GOOGLESHEETS_REQUEST]: getGoogleSheetsRequest,
    [IntegrationActionTypes.GET_GOOGLESHEETS_SUCCESS]: getGoogleSheetsSuccess,
    [IntegrationActionTypes.GET_GOOGLESHEETS_FAILURE]: getGoogleSheetsFailure,
};

export const googleSheetsWorksheetsHandlers = {
    [IntegrationActionTypes.GET_GOOGLE_SHEET_WORKSHEETS_REQUEST]: getGoogleSheetWorksheetRequest,
    [IntegrationActionTypes.GET_GOOGLE_SHEET_WORKSHEETS_SUCCESS]: getGoogleSheetWorksheetSuccess,
    [IntegrationActionTypes.GET_GOOGLE_SHEET_WORKSHEETS_FAILURE]: getGoogleSheetWorksheetFailure,
};

export const googleSheetsConfigHandlers = {
    [IntegrationActionTypes.UPDATE_GOOGLE_SHEETS_CONFIG_REQUEST]: updateGoogleSheetsConfigRequest,
    [IntegrationActionTypes.UPDATE_GOOGLE_SHEETS_CONFIG_SUCCESS]: updateGoogleSheetsConfigSuccess,
    [IntegrationActionTypes.UPDATE_GOOGLE_SHEETS_CONFIG_FAILURE]: updateGoogleSheetsConfigFailure,
};

export const integrationStatusesHandlers = {
    [IntegrationActionTypes.GET_INTEGRATION_STATUSES_REQUEST]: getIntegrationStatusesRequest,
    [IntegrationActionTypes.GET_INTEGRATION_STATUSES_SUCCESS]: getIntegrationStatusesSuccess,
    [IntegrationActionTypes.GET_INTEGRATION_STATUSES_FAILURE]: getIntegrationStatusesFailure,
};

export const mailchimpConfigHandlers = {
    [IntegrationActionTypes.UPDATE_MAILCHIMP_CONFIG_REQUEST]: updateMailchimpConfigRequest,
    [IntegrationActionTypes.UPDATE_MAILCHIMP_CONFIG_SUCCESS]: updateMailchimpConfigSuccess,
    [IntegrationActionTypes.UPDATE_MAILCHIMP_CONFIG_FAILURE]: updateMailchimpConfigFailure,
};
export const mailchimpAuthHandlers = {
    [IntegrationActionTypes.GET_MAILCHIMP_AUTH_URL_REQUEST]: getMailchimpAuthURLRequest,
    [IntegrationActionTypes.GET_MAILCHIMP_AUTH_URL_SUCCESS]: getMailchimpAuthURLSuccess,
    [IntegrationActionTypes.GET_MAILCHIMP_AUTH_URL_FAILURE]: getMailchimpAuthURLFailure,
};

export const mailchimpSelectedFieldsHandlers = {
    [IntegrationActionTypes.GET_MAILCHIMP_SELECTED_FIELDS_REQUEST]: getMailchimpSelectedFIeldsRequest,
    [IntegrationActionTypes.GET_MAILCHIMP_SELECTED_FIELDS_SUCCESS]: getMailchimpSelectedFIeldsSuccess,
    [IntegrationActionTypes.GET_MAILCHIMP_SELECTED_FIELDS_FAILURE]: getMailchimpSelectedFIeldsFailure,
};

export const mailchimpListsHandlers = {
    [IntegrationActionTypes.GET_MAILCHIMP_REQUEST]: getMailchimpRequest,
    [IntegrationActionTypes.GET_MAILCHIMP_SUCCESS]: getMailchimpSuccess,
    [IntegrationActionTypes.GET_MAILCHIMP_FAILURE]: getMailchimpFailure,
};
